/** Decimal Utilities
 * This module provides utilities for managing decimal numbers.
 */

/**
 * Gets the user's preferred locale from the browser
 * @returns The user's preferred locale or 'pt-BR' as fallback
 */
const getUserLocale = (): string => {
  if (typeof navigator !== 'undefined') {
    return navigator.language || navigator.languages?.[0] || 'pt-BR'
  }
  return 'pt-BR'
}

/**
 * Converts a decimal number to a localized string representation.
 * @param decimal - Decimal number to be converted to string
 * @param locales - Optional locales for formatting
 * @param minFractionDigits - Optional minimum fraction digits
 * @returns Localized string representation of the decimal number
 */
export const decimalToString = (
  decimal: number,
  locales?: Intl.LocalesArgument,
  minFractionDigits?: number
): string => {
  if (typeof decimal === 'number' && !Number.isNaN(decimal)) {
    return decimal.toLocaleString(locales ?? getUserLocale(), {
      maximumFractionDigits: 1,
      minimumFractionDigits: minFractionDigits ?? 0
    })
  } else {
    return '0'
  }
}
